import { render, staticRenderFns } from "./GalleryEdit.vue?vue&type=template&id=2e0d05d9&scoped=true"
import script from "./GalleryEdit.vue?vue&type=script&lang=js"
export * from "./GalleryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0d05d9",
  null
  
)

export default component.exports